import { Component, OnInit } from '@angular/core';
import { Role } from '../../const';
import { PowerBiReportService } from '../powerbi-report/powerbi-report.service';
import * as pbi from 'powerbi-client';
import { ToastrService } from 'ngx-toastr';
import { HttpErrorResponse } from '@angular/common/http';
import { SharedService } from '../../shared/services/shared.service';
import { MsalService } from '@azure/msal-angular';
import { combineLatest, debounceTime, firstValueFrom } from 'rxjs';
import { Subscription } from 'rxjs';
//import { MatTabChangeEvent } from '@angular/material/tabs';
import { IReportEmbedConfiguration } from 'embed';
import { BackgroundType, BasicFilter, HyperlinkClickBehavior, IAdvancedFilter, IBasicFilter, IBasicFilterWithKeys, IColumnTarget, IReportBookmark, ISlicer, ISlicerState, LayoutType, OnLoadFilters, PageSizeType, ReportAlignment, ReportLevelFilters, SectionVisibility, VisualContainerDisplayMode } from 'powerbi-models';
import { ContrastMode } from '../../models/contrast-mode.enum';
import { MatDialog } from '@angular/material/dialog';
import { SaveReportViewComponent } from './save-report-view/save-report-view.component';
import { DtoUserReportView } from "../../models/userProfile.model";
import { DtoSubCategory, PackageInformation } from '../../models/package-center.model';
import { ThemeService } from '../../shared/services/theme.service';
import { Router } from '@angular/router';


@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss'],
})
export class DashboardComponent implements OnInit 
{
  showReport = false;
  embedConfig: any={};
  userRole: string[] = [];
  roles = Role;
  roleName: string[] = [];
  userEmail: string = '';

  report: DtoSubCategory | null=null;
  report_context: DtoSubCategory | null=null;
  
  userId: string = '';
  schoolId: string = '';
  
  isLoading: boolean = false;
  isInitialised=false;

  packageInformation: PackageInformation={
    modules: []
  };
  reportInstance: pbi.Embed | null = null;

  ContrastMode = ContrastMode;
  currentContrastMode: number = 0;

  combinedSub: Subscription | undefined;
  dashboardActionSubscription: Subscription | undefined;

  reportPages: pbi.Page[] = [];
  allReportPages: pbi.Page[] = [];

  activePage: pbi.Page | null = null;
  reportPageSelectedIndex: number = -1;
  allReportPageSelectedIndex: number = -1;

  powerbiEmbedded: pbi.service.Service;
  constructor(
    private router: Router,
    private powerBiService: PowerBiReportService,
    private sharedService: SharedService,
    private toasterService: ToastrService,
    private msalService: MsalService,
    private dialog: MatDialog,
    private themeService: ThemeService
  ) {
    this.msalService.initialize();
    this.powerbiEmbedded = new pbi.service.Service(
          pbi.factories.hpmFactory,
          pbi.factories.wpmpFactory,
          pbi.factories.routerFactory
        );

    // this.powerbiEmbedded.preload({
    //     type: 'report',
    //     tokenType: pbi.models.TokenType.Embed,
    //     embedUrl: 'https://app.powerbi.com/reportEmbed?reportId=dummy'
    //   });
  }

  ngOnInit(): void {
    this.msalService.initialize();
    this.userRole = sessionStorage.getItem('user_role')?.split(',')!;
    this.userEmail = sessionStorage.getItem('user_email')!;
    this.userId = sessionStorage.getItem('user_id')!;
    this.setRoleName();
    
    const savedContrastMode = Number(sessionStorage.getItem('contrastMode')) || 0;
    this.currentContrastMode = savedContrastMode;
    this.sharedService.setContrastMode(savedContrastMode);
    this.dashboardActionSubscription = this.sharedService.dashboardActionCommand$
      .subscribe(([command, args]) => {
        this.handleDashboardActionCommand(command, args); // Pass both command and value
      });

    this.sharedService.isPopupWindowClosing.subscribe((isclosing)=>{
      if(isclosing) this.closePopUp();
    });

    this.combinedSub = combineLatest([
      this.sharedService.currentReport,
      this.sharedService.contrastMode$
    ])
      .pipe(
        debounceTime(100)       
      )
      .subscribe(([data, mode]) => {
        this.isInitialised=true;
        const eventData = data as  [PackageInformation, DtoSubCategory|null, string];
        const packageInformation = eventData[0];
        const reportContext =  eventData[1];
        const eventHint = eventData[2];

        
        this.packageInformation = packageInformation;
        this.report_context = reportContext;
        var reportData = reportContext;
        

        if(eventHint=='landingpage'){
          reportData = null;
        }

        if (!reportData || !reportData.reportId)
        {
          const reportContainer = document.getElementById('reportContainer');
          if(reportContainer){
            this.powerbiEmbedded.reset(reportContainer);
          }
          this.report = null;
          this.isLoading=false;
          return;
        }
        
        if(reportData.userReportViewId==null) reportData.userReportViewId=0;
        this.report = reportData;
        this.currentContrastMode = mode;
        this.generateReport(eventHint);
      });

  }


  ngOnDestroy(): void {
    this.combinedSub?.unsubscribe();
    this.dashboardActionSubscription?.unsubscribe();
    
  }

  handleDashboardActionCommand(command: string, command_args: number|string|null=null){
    
    switch(command){
      case 'printreport':
        this.printReport();
        break;
      case 'fullscreen':
        this.goFullScreen();
        break;
      case 'refresh':
        this.onViewReload();
        break;

      case 'saveview':
        this.onViewSave();
        break;
      case 'saveview_as':
        this.onViewSaveAs();
        break;
      case 'startupReport':
        this.onViewStartup(Number(command_args));
        break;
      default:
        this.toasterService.error('Unhandled command: '+ command,'Dashbord Command')
        break;
    }
    
  }

  
    printReport() {
      const reportContainer = document.getElementById('reportContainer');
  
      if (reportContainer) {
        const report = this.powerbiEmbedded.get(reportContainer) as pbi.Report;
  
        if (report) {
          report.print();
        } else {
          console.warn('No embedded report to print.');
        }
      } else {
        console.warn('Report container not found.');
      }
    }


  // adjustMenuPosition(){
  //   const isFullscreen = document.fullscreenElement !== null;
    
  //   // if (isFullscreen) {
  //   //   // Adjust the parent element’s styles when in fullscreen mode
  //   //   this.parentElement.nativeElement.style.position = 'relative';
  //   //   this.parentElement.nativeElement.style.zIndex = '9999'; // Ensure the parent is on top
  //   // } else {
  //   //   // Reset the styles when exiting fullscreen
  //   //   this.parentElement.nativeElement.style.position = '';
  //   //   this.parentElement.nativeElement.style.zIndex = '';
  //   // }
  // }

  goFullScreen() {

    // const reportWrapper = document.getElementById('reportWrapper');
    // reportWrapper?.requestFullscreen();
    // return;
    
    const reportContainer = document.getElementById('reportContainer');

    if (reportContainer) {
      const report = this.powerbiEmbedded.get(reportContainer);

      if (report) {
        report.fullscreen();
      } else {
        console.warn('No embedded report found to go full screen.');
      }
    } else {
      console.warn('Report container not found.');
    }
  }
  
  // private fetchReportPages() {
  //   const report = this.reportInstance as pbi.Report;
  
  //   this.activePage = null;
  //   this.allReportPageSelectedIndex=-1;
  //   this.reportPageSelectedIndex=-1;

  //   if (report) {
  //     report.getPages().then(pages => {
  //       this.allReportPages = pages;
  //       this.reportPages = pages.filter((x)=>x.visibility == SectionVisibility.AlwaysVisible);
  //     });
  //   }

  //   this.reportInstance!.on('pageChanged', (event: any) => {
  //         const pageName = event.detail.newPage;

  //   this.syncTabWithPage(pageName);
  // });
  // }

  // syncTabWithPage(page: pbi.Page): void {
  //   this.activePage = page;
  //   const index = this.reportPages.findIndex(p => p.name === page.name);
  //   if (index !== -1) {
  //     this.reportPageSelectedIndex = index;
  //     this.allReportPageSelectedIndex=-1;
  //   }
  //   else{
  //     this.allReportPageSelectedIndex= this.allReportPages.findIndex(p => p.name === page.name);
  //   }
    
  // }
  
  // navigateToPage(event: MatTabChangeEvent) {
  //   if(this.allReportPageSelectedIndex!=-1) return;

  //   const page = this.reportPages[event.index];
  //   const report = this.reportInstance as pbi.Report;
  //   if (report) {
  //     report.setPage(page.name).then(() => {
  //       this.activePage = page;
  //     });
  //   }
  // }


  setRoleName() {
    if (
      !this.userRole?.includes(this.roles.SuperAdmin) &&
      !this.userRole?.includes(this.roles.AccountAdmin) &&
      !this.userRole?.includes(this.roles.SchoolAdmin)
    ) {
      this.roleName = [];
    } else {
      this.userRole?.forEach((element) => {
        this.roleName.push(this.getRoleNameByValue(Role, element)!);
      });
    }
  }

  async onViewReload() {
    const report = this.reportInstance as pbi.Report;

    var thisPage = await report.getActivePage();
    var currentPageName = thisPage.name;
    report.on('loaded', () => {
    
      report.off('loaded')

      var newPage = report.getPageByName(currentPageName)
      .then(
            (pn)=>
            {
               report.setPage(pn.name);
               this.activePage = pn;
            }
          );

    });

    report.reload().then(()=>
      {
        if((this.report!.userReportViewId??0)!=0)
          this.applyCurrentReportViewState()
      }
    );

    
  }


  async onViewStartup(subcategoryId: number){
    var data = this.sharedService.getUserProfile();
    const report = this.reportInstance as pbi.Report

    if(data.startupSubcategory == subcategoryId)
    {
      data.startupSubcategory = null;
      data.pageName=null;
    }
    else
    {
      data.startupSubcategory = subcategoryId;
      const pageName = await report.getActivePage();
      data.pageName=pageName.name;
      
    }
    this.sharedService.saveUserProfile('startupSubcategory');
  }

  async getAllSlicerStates(report: pbi.Report): Promise<{pageName: string,visualName:string, state:ISlicerState}[]> 
  {
    //const pages = await report.getActivePage();
    const page = await report.getActivePage();
    const allSlicers:{pageName: string,visualName:string, state:ISlicerState}[]=[];

    //const visuals = await page.getVisuals();
    const visuals = await page.getSlicers()
    
    for (const visual of visuals) {
      if (visual.type === 'slicer') {
        const slicer = visual as pbi.VisualDescriptor;//& pbi.spl;
        const state = await slicer.getSlicerState();
        
        allSlicers.push({
          pageName: page.name,
          visualName: visual.name,
          state
        });
      }
    }

    return allSlicers;
  }


  async onViewSaveAs() {
    if(this.isLoading){
      this.toasterService.warning('The toolkit still loading. Please try later.','Save View')
      return;
    }
    const report = this.reportInstance as pbi.Report;
    
    var dialogRef = this.dialog.open(SaveReportViewComponent, {
      width: '600px',
      data:this.report?.reportId
    });


    dialogRef.afterClosed().subscribe(async result => {
      var loginToken = this.sharedService.getLoginToken();

      if (result) {
        const viewName = result.viewName;
        var snapShotData: string;
        if(result.snapshotType=='Filters')
        {
          const slicers = await this.getAllSlicerStates(report);
          snapShotData = JSON.stringify(slicers);
        }
        else
        {
          const bookmark = await report.bookmarksManager.capture({allPages: false, personalizeVisuals:false});
          snapShotData = JSON.stringify(bookmark);
        }
      
        const snapshotType = result.snapshotType;
        const urvData: DtoUserReportView = {
          userReportViewId: 0,
          userId: loginToken.userId,
          subCategoryId: this.report?.subCategoryId!,
          viewName: viewName,
          snapShotType: snapshotType,
          snapShotData: snapShotData,
          isFavourite: true,
          isStartup: false,
          isShared: false
        };
        var tsv = this.toasterService;
        this.powerBiService.SaveUserReportView(urvData).subscribe(
          {
            next:(response)=>{
              var newView = response as DtoUserReportView;
              tsv.success(newView.viewName + ' has been saved.','Analytics Personalisation');
              this.sharedService.triggerUserReportViewSource(newView, 'save_as')
             
            },
            error(err) {
              tsv.error('Error saving analytics personalisation settings','Analytics Personalisation');
            },
          }
        );
      
        
      }
    });
    
  }

  async saveReportView(reportView: DtoUserReportView){
    
    var snapShotData: string;

    const report = this.reportInstance as pbi.Report;
    const loginToken = this.sharedService.getLoginToken();

    if(reportView.snapShotType=='Filters')
    {
      const slicers = await this.getAllSlicerStates(report);
      snapShotData = JSON.stringify(slicers);
    }
    else
    {
      const bookmark = await report.bookmarksManager.capture({allPages: false, personalizeVisuals:false});
      snapShotData = JSON.stringify(bookmark);
    }
  
    const urvData: DtoUserReportView = {
      userReportViewId: (reportView.userReportViewId??0),
      userId: loginToken.userId,
      subCategoryId: reportView.subCategoryId,
      viewName: reportView.viewName,
      snapShotType: reportView.snapShotType,
      snapShotData: snapShotData,
      isFavourite: reportView.isFavourite,
      isStartup: reportView.isStartup,
      isShared: reportView.isShared
    };
    var tsv = this.toasterService;
    this.powerBiService.SaveUserReportView(urvData).subscribe(
      {
        next:(response)=>{
          var newView = response as DtoUserReportView;
          tsv.success(newView.viewName + ' has been saved.','Analytics Personalisation');
          this.sharedService.triggerUserReportViewSource(newView, 'save')
          
        },
        error(err) {
          tsv.error('Error saving analytics personalisation settings','Analytics Personalisation');
        },
      }
    );
  }

  async onViewSave() {
      //const report = this.reportInstance as pbi.Report;
      const urvId = (this.report?.userReportViewId??0);
      if(urvId==0)
      {
          this.onViewSaveAs();
        return;
      }

      this.powerBiService.GetUserReportView(this.report?.userReportViewId!)
      .subscribe(
        {
          next:(response)=>{
            this.saveReportView(response as DtoUserReportView);
          },
          error:(error)=>this.toasterService.error('Error retrieving report view data', 'Error')
        }
      );
      
  }

  closePopUp(){
    this.router.navigate([
    {
      outlets: {
        popup: null
      }
    }
    ],
    {
      skipLocationChange: true,
      onSameUrlNavigation: 'reload'
    });
  }

  openPopUp(url:string){
    const segments = url.replace(/^\/+|\/+$/g, '').split('/');
    this.router.navigate([
      {
        outlets: {
          popup: segments
        }
      }
    ],
    {
      skipLocationChange: true,
      onSameUrlNavigation: 'reload'
    });
  }

  async generateReport(eventHint: string) {
    if (!this.report?.reportId) {
      return;
    }
    
    const loadingRequestId = crypto.randomUUID();
    if(this.isLoading){
      
        const reportContainer = document.getElementById('reportContainer');
        
        if (reportContainer) {
          // Reset the existing embedded report (if any)
          this.powerbiEmbedded.reset(reportContainer);
        }
        
    }
    
    if(eventHint==='loadview' && this.reportInstance?.embedtype=='report'){
      if(this.reportInstance && this.reportInstance.getId() == this.report?.reportId){
        if(await this.applyCurrentReportViewState()) return;
      }
    }
  

    
    //eventHint
    const contrastMode = (this.currentContrastMode==0?null:this.currentContrastMode);
    
    this.embedConfig = {};
    this.showReport = false;
    this.isLoading = true;
    var reportView: DtoUserReportView|null = null;
    var reportViewBookmark:IReportBookmark|null = null;
    var reportSlicerStates: {pageName: string,visualName:string, state:ISlicerState}[] |null= null;
    
    const loadingReport = this.report;
    var startupPage = loadingReport.startupPageName;
    

    if((loadingReport.userReportViewId??0)!=0)
    {
      reportView = await firstValueFrom(this.powerBiService.GetUserReportView(loadingReport.userReportViewId!));
      
      if(reportView!.snapShotType=='Snapshot'){
        startupPage = null;
        reportViewBookmark = JSON.parse(reportView!.snapShotData) as IReportBookmark;
      }
      else{
        reportSlicerStates = JSON.parse(reportView!.snapShotData) as {pageName: string,visualName:string, state:ISlicerState}[];
      }
      // this.toasterService.info(`Loading ${reportView!.viewName}`,'Toolkit View')
    }
    
    var apiUrl = this.powerBiService.getApiUrl();
    if(!apiUrl.startsWith('http'))
      apiUrl = document.location.protocol + "//" + document.location.host + apiUrl;
    
    const client_account = Number(sessionStorage.getItem('client_account'));
    const my_ref_school_id = sessionStorage.getItem('my_ref_school_id');
    const schoolId = Number(sessionStorage.getItem('school_id'));

    let tokenDetails = {
      userAccessToken: '', //response.accessToken
      reportId: loadingReport.reportId,
      clientAccountId: client_account,
      subcategoryId: loadingReport.subCategoryId,
      myRefSchoolId: my_ref_school_id,
      schoolId: schoolId,
      apiUrl: apiUrl
    };
    
    const showReport = () => {
     
      //this.fetchReportPages();
      if(this.isLoading == false) return;
      //Give some time for the default powerbi logo to
      setTimeout(() => {
        this.isLoading = false;
      }, 2000); // 2000 ms = 2 seconds
    };

    const showReportError = (error: any) => {
      console.error('Error loading Power BI report:', JSON.stringify(error));
      //this.toasterService.error(JSON.stringify(error));
      showReport();
    };

    this.powerBiService.getEmbedDetails(tokenDetails)
    .subscribe({
      next:(response: any) => {
        var data = response.embedDetails;
        this.showReport = true;

        if(data.reportType==='PaginatedReport'){
          this.embedConfig = {
                    type: 'report',//'paginatedReport',
                    id: data.reportId,
                    embedUrl: data.embedUrl,
                    accessToken: data.embedToken.token, 
                    tokenType: pbi.models.TokenType.Embed, //pbi.models.TokenType.AAD
                    settings:{
                      commands:{
                        parameterPanel:{
                          enabled:false,
                          expanded:false
                        }
                      }
                    },
                    parameterValues:[
                      {
                        name:'studentID', value:'99'
                      }
                    ]
                  };
        }
        else if(data.reportType==='PowerBIReport'){
          
          //const themeJson = this.getCustomThemeJson();
          //this.toasterService.info(data.embedToken.Expiration);
          this.embedConfig = {
                    type: 'report',
                    //theme: {themeJson: themeJson},
                    tokenType: pbi.models.TokenType.Embed, //pbi.models.TokenType.AAD
                    accessToken: data.embedToken.token,
                    embedUrl: data.embedUrl,
                    permissions: pbi.models.Permissions.Read,
                    settings: {
                      //customLoadingMessage:'Loading your insights',
                      filterPaneEnabled: false,
                      navContentPaneEnabled: false,

                      background: BackgroundType.Transparent,
                      //theme: { themeJson: themeJson },
                      authoringHintsEnabled: false,
                      hyperlinkClickBehavior: HyperlinkClickBehavior.RaiseEvent,
                      bars:{
                        statusBar:{
                          visible: true
                        },
                        actionBar:{
                          visible: false
                        }
                      },
                      
                      // customLayout:{
                      //   reportAlignment: ReportAlignment.Left,
                      //   displayOption: DisplayOption.FitToPage,
                      //   pageSize: {
                      //     type: PageSizeType.Widescreen,
                      //   }
                      // },
                      layoutType: LayoutType.Master
                    },
                    filters: this.getFilterProperties(),
                    //slicers: this.getSlicerStates(),
                    contrastMode: contrastMode,
                    bookmark: reportViewBookmark?{
                      state: reportViewBookmark.state
                    }:null,
                    //slicers: null,//reportSlicerStates
                    pageName: startupPage
                  } as IReportEmbedConfiguration;                  
        }
        else{
          showReportError('Unknown report type ' + data.reportType);
          return;
        }
        
        const reportContainer = document.getElementById('reportContainer');
        
        if (!reportContainer) return;
        
        // Reset the existing embedded report (if any)
        this.powerbiEmbedded.reset(reportContainer);
        
        if (this.showReport) {
          if(data.reportType==='PaginatedReport'){
            this.reportInstance = this.powerbiEmbedded.embed(reportContainer, this.embedConfig);
            showReport();
          }
          else if(data.reportType==='PowerBIReport'){
            //this.reportInstance = powerbi.load(reportContainer, this.embedConfig);
            this.reportInstance = this.powerbiEmbedded.embed(reportContainer, this.embedConfig);
            const report = this.reportInstance as  pbi.Report;

            // Event listener for report load
            
            this.reportInstance.off('renderingStarted');
            this.reportInstance.off('loaded');
            this.reportInstance.off('rendered');
            this.reportInstance.off('error');
            this.reportInstance.off('dataHyperlinkClicked')
            this.reportInstance.off('buttonClicked')

            var isRendered = false;
            this.reportInstance.on('buttonClicked',(event)=>{
              let details = event.detail as any;
              
              if(details.type=='WebUrl' && details.title.startsWith('https://deesha/'))
              {
                const url=details.title;
                const route = url.replace(/^https:\/\/deesha\//, '');
                this.openPopUp(route)
              }
            });
            this.reportInstance.on('dataHyperlinkClicked', (event) => {
              let details = event.detail as any;
              let url = details.url;

              if (url.startsWith('https://deesha/')) {
                const route = url.replace(/^https:\/\/deesha\//, '');
                this.openPopUp(route)
              }
              else{
                window.open(url,'_blank');
              }
            });

            this.reportInstance.on('renderingStarted', ()=>{
              isRendered=true;
              showReport();
            });
            
            this.reportInstance.on('loaded', async () => {
              
              const firstPage = await report.getActivePage();
              
              //this.applyTheme(report)
              //await this.hidePageSingleSchoolSlicer(firstPage);
                  
              //apply slicers
              //this.reportInstance.getac
              if(reportSlicerStates!=null && reportSlicerStates.length > 0)
              {
                await this.setSlicersFromState(firstPage, reportSlicerStates!); 
              }
            });  
            
            // report.on("pageChanged", async (event: any)=>
            // {
            //   const newPage = event.detail.newPage;
            //   await this.hidePageSingleSchoolSlicer(newPage);
            // });
            this.reportInstance.on('rendered', async () => {
              this.reportInstance?.off('rendered');
              //await this.hideSingleSchoolSlicer( report);
              if(!isRendered)
                showReport();
            });

            this.reportInstance.on('error', (error) => {
              showReportError(error);
            });
          }
        }
      
      },
      error:(err: HttpErrorResponse) => {
        if (err.error) {
          this.toasterService.error(err.error, 'Error');
          this.report = null;
          this.showReport = false;
          this.isLoading = false;
        }
      }
    });
  }

  async applyCurrentReportViewState(){
    if(this.report==null) return false;
    if((this.report.userReportViewId??0)==0) return false;
    const report = this.reportInstance  as  pbi.Report;
    const userReportViewId = this.report!.userReportViewId!;
    const reportView = await firstValueFrom( this.powerBiService.GetUserReportView(userReportViewId));

    if(reportView!.snapShotType=='Filters'){
      const reportSlicerStates = JSON.parse(reportView!.snapShotData) as {pageName: string,visualName:string, state:ISlicerState}[];
      if(reportSlicerStates!=null && reportSlicerStates.length > 0)
      {
        report.getActivePage()
        .then((activePage)=>{
          this.setSlicersFromState(activePage, reportSlicerStates!);
        });
      }

      return true;
    }
    // else{
    //   const reportViewBookmark = JSON.parse(reportView!.snapShotData) as IReportBookmark;
    //   report.bookmarksManager.applyState(reportViewBookmark!.state!);
    // }
    
    return false;
  }

  async setSlicersFromState(page: pbi.Page, slicerStates: {pageName: string,visualName:string, state:ISlicerState}[]){
    const slicers = await page.getSlicers(); 
   
    for (const visual of slicers) {
      const slicerTitle = visual.title;
      const slicer = visual as pbi.VisualDescriptor

      var state = await slicer.getSlicerState();
         
      if(state.targets==null || state.targets.length == 0){
         continue;
      }
      
      for(const target of state.targets){
        const ct = target as IColumnTarget;
        const tableName = ct.table;
        const columnName = ct.column;
        
        var applyStates = slicerStates.find(st=>st.state.targets!=null && st.state.targets.find(
            t=>{
              const tv = t as IColumnTarget;
              return tv.table == tableName && tv.column==columnName
            }
          ));

          if(applyStates!=null){
            var newState = applyStates.state;
            var thisState = state;
            thisState.filters=newState.filters;
            
            slicer.setSlicerState(thisState);
          }
        }
    }

  }

  getCustomThemeJson(){
    const themeName = this.themeService.ActiveThemeClass;
   
    const el = document.querySelector(`body.${themeName}`);
    const computedStyle = getComputedStyle(el!);
    const primary = computedStyle.getPropertyValue('--theme-primary').trim();
    const secondary = computedStyle.getPropertyValue('--theme-secondary').trim();
    const cards = computedStyle.getPropertyValue('--theme-cards').trim();
    const cardText = computedStyle.getPropertyValue('--theme-card-text').trim(); 
    const primaryHover = computedStyle.getPropertyValue('--theme-primary-hover').trim(); 
    const primaryHoverText = computedStyle.getPropertyValue('--theme-primary-hover-text').trim(); 
    
    const themeJson = {
      "name": `deesha theme ${themeName}`,
      // "firstLevelElements": "#252423",
      // "secondLevelElements": "#605E5C",
      // "thirdLevelElements": "#F3F2F1",
      // "fourthLevelElements": "#B3B0AD",
      //"background": "#FaaF0F",
      // "secondaryBackground": "#C8C6C4",
      // "tableAccent": "#118DFF",
      // "textClasses": {
      //     "callout": {
      //         "fontSize": 45,
      //         "fontFace": "DIN",
      //         "color": "#252423"
      //     },
      //     "title": {
      //         "fontSize": 12,
      //         "fontFace": "DIN",
      //         "color": "#252423"
      //     },
      //     "header": {
      //         "fontSize": 12,
      //         "fontFace": "Segoe UI Semibold",
      //         "color": "#252423"
      //     },
      //     "label": {
      //         "fontSize": 10,
      //         "fontFace": "Segoe UI",
      //         "color": "#252423"
      //     }
      // },
       "visualStyles":{
          "slicer":{
            "*":{
               "background": [
                    {
                        "show": true
                    },
                    {"color":{"solid":{"color":"#252423"}}},
                    {"transparency": 0}
                ],
              "items":[
                {
                  "fontColor": {"solid":{"color": cardText}},
                  "background":{"solid": {"color": cards}},
                  "selected": {
                    "background": {
                      "solid": {
                        "color": "#ffffff"
                      }
                    },
                    "fontColor": {
                      "solid": {
                        "color":  "#ffffff"
                      }
                    }
                  }
                }
              ]
            }
          },
          "pageNavigator":{
            "*": {
              "fill":[{"show": true},
                {"$id": "default", "transparency": 1,  "fillColor": {"solid":{"color":secondary}}},
                {"$id": "selected", "transparency": 1,  "fillColor": {"solid":{"color":primary}}},
                {"$id": "hover", "transparency": 1,  "fillColor": {"solid":{"color":primaryHover}}},
                {"$id": "press", "transparency": 1,  "fillColor": {"solid":{"color":primary}}},
              ]
            }},
          "bookmarkNavigator" : {
			  "*": {
				"outline": [
          {
            "$id": "default",
            //"transparency": 0,
            "lineColor": {"solid":{"color":"#FFFFFF"}},
            "weight": 1
          },
          {
            "$id": "hover",
            //"transparency": 0,
            "lineColor": {"solid":{"color":"#FFFFFF"}},
            "weight": 2
          },
          {
            "$id": "press",
            //"transparency": 0,
            "lineColor": {"solid":{"color":"#FFFFFF"}},
            "weight": 1
          },
          {
            "$id": "selected",
            //"transparency": 0,
            "lineColor": {"solid":{"color":"#FFFFFF"}},
            "weight": 2
          }
        ],
				"fill": [{
					"show": true
				},{
					"$id": "default",
					"transparency": 1,
					//"fillColor": {"solid":{"color":"#FFFFFF"}}
				},{
					"$id": "hover",
					"transparency": 1,
					//"fillColor": {"solid":{"color":"#FFFFFF"}}
				},{
					"$id": "press",
					"transparency": 1,
					//"fillColor": {"solid":{"color":"#FFFFFF"}}
                },{
					"$id": "selected",
					"transparency": 1,
					//"fillColor": {"solid":{"color":"#FFFFFF"}}
          }
        ],
				"text": [
          {
					"show": true
				},{
					"$id": "default",
					"fontColor": {"solid":{"color":"#FFFFFF"}},
					
				},{
					"$id": "hover",
					"fontColor": {"solid":{"color":"#FFFFFF"}}
				},{
					"$id": "press",
					"fontColor": {"solid":{"color":"#FFFFFF"}}
				},{
					"$id": "selected",
					"fontColor": {"solid":{"color":"#FFFFFF"}}
				}]
			}
		}
      }
    };

    return themeJson;
  }

  // async hideSingleSchoolSlicer(report: pbi.Report){
  //   const pages = await report.getPages();
  //   for(const page of pages)
  //     await this.hidePageSingleSchoolSlicer(page);
  // }

  // async hidePageSingleSchoolSlicer(page: pbi.Page) {
  //   const my_ref_school_id_list = sessionStorage.getItem('my_ref_school_id');
  //   if (my_ref_school_id_list && my_ref_school_id_list!='') 
  //   {
  //     const schoolList = my_ref_school_id_list.split(',');
  //     if(schoolList.length!=1) return;
  //   }
    
  //   const visuals = await page.getSlicers();

  //   for (const visual of visuals) {
      
  //     const slicer = visual as pbi.VisualDescriptor;
  //     const state = await slicer.getSlicerState();
      
  //     const schoolEntityTarget = state.targets?.find(x=>{
  //       const ct = x as IColumnTarget;
        
  //       return ct.table=='SchoolEntity' ||
  //               ct.table=='Dim - School'
  //     })
      
  //     if(!schoolEntityTarget) continue;
     
  //     //rls will ensure only one school is there
  //     slicer.setVisualDisplayState(VisualContainerDisplayMode.Hidden);
      
  //   }
    
  // }
  


  // getSlicerStates() :ISlicer[]
  // {
  //   const singleSchool = [
  //     {
  //       selector:{
  //         target: {
  //           $schema: 'http://powerbi.com/product/schema#basic',
  //           table: 'SchoolEntity',
  //           column: 'My_Reference_School_Code',
  //         },
  //       },
  //       state:{
  //         filters: [
  //                   {
  //                     $schema: 'http://powerbi.com/product/schema#advanced',
  //                     target: {
  //                       table: 'SchoolEntity',
  //                       column: 'My_Reference_School_Code',
  //                     },
  //                     logicalOperator: 'And',
  //                     conditions: [{
  //                       value:'HKDBIS',
  //                       operator: 'Is'
  //                     }]
  //                   } as IAdvancedFilter
  //                 ]
  //       }
        
  //     } as ISlicer
  //   ];
  //   return singleSchool;
  // }

  getFilterProperties(): ReportLevelFilters[] | OnLoadFilters 
  {
    const client_account = Number(sessionStorage.getItem('client_account')??0);
    const my_ref_school_id_list = sessionStorage.getItem('my_ref_school_id');

    var filters:ReportLevelFilters[] = [];

    if (my_ref_school_id_list && my_ref_school_id_list!='') 
    {
      const schoolList = my_ref_school_id_list.split(',');
      if(client_account==0 && schoolList.length>1){
        this.toasterService.error('Cannot browse multiple schools that belong to differene accounts.');
        throw 'Cannot browse multiple schools that belong to differene accounts.'
      }

      const schoolFilter: IAdvancedFilter|ReportLevelFilters = 
        schoolList.length==1?
        {
          $schema: 'http://powerbi.com/product/schema#advanced',
          target: {
            table: 'SchoolEntity',
            column: 'My_Reference_School_Code',
          },
          logicalOperator: 'And',
          conditions: [{
            value:schoolList[0],
            operator: 'Is'
          }]
        } as IAdvancedFilter
        :
        {
          $schema: 'http://powerbi.com/product/schema#basic',
          filterType: pbi.models.FilterType.Basic,
          logicalOperator: "Or",
          target: {
            table: 'SchoolEntity',
            column: 'My_Reference_School_Code',
          },
          operator: 'In',
          values: schoolList
        } as ReportLevelFilters;
      
        filters.push(schoolFilter);

    } 

    if ( client_account > 0) 
    {
      const clientFilter = 
        {
          $schema: 'http://powerbi.com/product/schema#advanced',
          target: {
            table: 'SchoolEntity',
            column: 'ClientAccountId',
          },
          logicalOperator: 'And',
          conditions: [{
            value:client_account,
            operator: 'Is'
          }]
        } as IAdvancedFilter;

        filters.push(clientFilter);
    }
    return filters;
  }

  getRoleNameByValue<T extends { [index: string]: string }>(
    enumObj: T,
    value: string
  ): string | undefined {
    const keys = Object.keys(enumObj).filter((x) => enumObj[x] === value);
    return keys.length > 0 ? keys[0] : undefined;
  }
}
